module.exports = __webpack_public_path__ + "media/images/cloud-cma-badge-tiny-608bdbaa.svg";